export function parseIntWithDefault(string: string | undefined, radix?: number, def?: number): number | undefined {
    if (string === undefined) return def
    const value = parseInt(string, radix)
    return isNaN(value) ? def : value
}
